import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import MedicalSoftwareQuotesWrapper from "@components/layouts/medicalsoftwareWrapper";

import { getPageProps } from "@services/initial-calls";

export default function MedicalSoftwareHome(): ReactElement {
    return (
        <MedicalSoftwareQuotesWrapper>
            <PrivacyPolicy
                domain="MedicalSoftwareQuotes.com"
                category="Medical Software"
            />
        </MedicalSoftwareQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
